
/// <amd-module name="Build/Diag/Launch" />
import * as React from "react";

import { Timeline } from "Build/Diag/Timeline";

import { Components, IVssLayoutManager, VssComponent } from "VSS/Platform/Layout";

import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";

export class Launch extends VssComponent {
    public render() {
        return <div className="build-diag-launcher">
            &nbsp;
            <Icon iconName="Build" /> &nbsp;
            <span>Pipeline helpers: </span>
            &nbsp;
            <Button
                text="Timeline analysis"
                iconProps={
                    {
                        iconName: "ViewListTree"
                    }
                }
                onClick={this._onTriggerClick}
            />
        </div>;
    }

    private _onTriggerClick = () => {
        const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout((onDismiss) => {
            return React.createElement(Timeline, {
                onDismiss: onDismiss
            }, null);
        });
    }
}

Components.add("build.diag.launch", Launch);